import { ButtonLink } from '@razz-team/ui-web';

export function CardButtonLink({
  card: { cardId, lastFour, name },
}: {
  card: {
    cardId: string;
    lastFour?: null | string;
    name?: null | string;
  };
}) {
  const text = [name, lastFour ? `••${lastFour}` : null].filter(Boolean).join(', ');
  return (
    <ButtonLink to="/account/cards/$cardId" params={{ cardId }} variant="text" color="info">
      {text}
    </ButtonLink>
  );
}
